var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-drawer',{ref:"drawer",staticClass:"drawer",attrs:{"visible":_vm.drawer,"direction":_vm.direction,"destroy-on-close":true,"size":_vm.size},on:{"update:visible":function($event){_vm.drawer=$event},"opened":_vm.getlist}})}
var staticRenderFns = []

export { render, staticRenderFns }